<template>
  <div class="contact-page">
    <!-- 头部导航 - 使用公共组件 -->
    <Navbar />

    <!-- Hero Section -->
    <section class="hero-section" :style="{ backgroundImage: `url(${heroBackground})` }">
      <div class="hero-overlay"></div>
      <div class="container">
        <div class="hero-content">
          <h1 class="hero-title">联系我们</h1>
          <p class="hero-subtitle">专业服务，随时为您提供咨询</p>
          <p class="hero-description">
            我们期待与您的合作，为您提供专业的工业安全检测服务。无论是项目咨询还是技术问题，我们都将竭诚为您服务
          </p>
        </div>
      </div>
    </section>

    <!-- 主要联系区域 -->
    <section class="main-contact-section">
      <div class="container">
        <div class="contact-wrapper">
          <!-- 左侧：联系表单 -->
          <div class="contact-form-wrapper">
            <h2 class="section-title">在线咨询</h2>
            <p class="form-subtitle">请填写以下信息，我们将尽快与您联系</p>
            <el-form :model="contactForm" :rules="formRules" ref="contactForm" label-width="80px" class="contact-form">
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="姓名" prop="name">
                    <el-input v-model="contactForm.name" placeholder="请输入您的姓名"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系电话" prop="phone">
                    <el-input v-model="contactForm.phone" placeholder="请输入联系电话"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="公司名称">
                    <el-input v-model="contactForm.company_name" placeholder="请输入公司名称（选填）"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="邮箱地址" prop="email">
                    <el-input v-model="contactForm.email" placeholder="请输入邮箱地址"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="检测需求">
                <el-select v-model="contactForm.test_requirement" placeholder="请选择检测服务类型（选填）" style="width: 100%">
                  <el-option label="空气呼吸器检测" value="空气呼吸器检测"></el-option>
                  <el-option label="气体报警仪检测" value="气体报警仪检测"></el-option>
                  <el-option label="气瓶检测" value="气瓶检测"></el-option>
                  <el-option label="综合检测服务" value="综合检测服务"></el-option>
                  <el-option label="其他咨询" value="其他咨询"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="详细需求" prop="content">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="contactForm.content"
                  placeholder="请详细描述您的检测需求、设备数量、时间要求等信息"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm" :loading="submitting" size="large">
                  <i class="el-icon-s-promotion"></i>
                  提交咨询
                </el-button>
                <el-button @click="resetForm" size="large">
                  <i class="el-icon-refresh"></i>
                  重置表单
                </el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- 右侧：详细信息 -->
          <div class="contact-details-wrapper">
            <h2 class="section-title">联系方式</h2>
            
            <!-- 联系信息列表 -->
            <div class="details-list">
              <div class="detail-item" v-if="settings.site_name">
                <div class="detail-icon">
                  <i class="el-icon-office-building"></i>
                </div>
                <div class="detail-content">
                  <h4>公司全称</h4>
                  <p>{{ settings.site_name }}</p>
                </div>
              </div>
              <div class="detail-item" v-if="settings.address">
                <div class="detail-icon">
                  <i class="el-icon-location-information"></i>
                </div>
                <div class="detail-content">
                  <h4>详细地址</h4>
                  <p>{{ settings.address }}</p>
                </div>
              </div>
              <div class="detail-item" v-if="settings.contact_phone">
                <div class="detail-icon">
                  <i class="el-icon-phone"></i>
                </div>
                <div class="detail-content">
                  <h4>客服热线</h4>
                  <p>{{ settings.contact_phone }}</p>
                  <span class="detail-note">工作日 9:00-18:00 专业客服在线</span>
                </div>
              </div>
              <div class="detail-item" v-if="settings.contact_email">
                <div class="detail-icon">
                  <i class="el-icon-message"></i>
                </div>
                <div class="detail-content">
                  <h4>商务邮箱</h4>
                  <p>{{ settings.contact_email }}</p>
                  <span class="detail-note">24小时内专业回复</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部区域 - 使用公共组件 -->
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import request from '@/utils/request'
import settingsMixin from '@/mixins/settingsMixin'

export default {
  name: 'Contact',
  mixins: [settingsMixin],
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
      heroBackground: require('@/assets/email.jpg'),
      submitting: false,
      contactForm: {
        name: '',
        phone: '',
        company_name: '',
        email: '',
        test_requirement: '',
        content: ''
      },
      formRules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '姓名长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请描述您的具体需求', trigger: 'blur' },
          { min: 10, max: 500, message: '需求描述长度在 10 到 500 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async submitForm() {
      this.$refs.contactForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          
          try {
            const response = await request.post('/api/messages', this.contactForm)
            
            if (response.code === 200) {
              this.$message.success('咨询信息提交成功！我们将在24小时内与您联系。')
              this.resetForm()
            } else {
              this.$message.error(response.message || '提交失败，请稍后重试')
            }
          } catch (error) {
            console.error('提交留言失败:', error)
            this.$message.error('提交失败，请稍后重试')
          } finally {
            this.submitting = false
          }
        } else {
          this.$message.error('请完善表单信息')
          return false
        }
      })
    },
    resetForm() {
      this.$refs.contactForm.resetFields()
      this.contactForm = {
        name: '',
        phone: '',
        company_name: '',
        email: '',
        test_requirement: '',
        content: ''
      }
    }
  },
  async mounted() {
    await this.fetchSettings()
    document.title = this.settings.site_name ? `联系我们 - ${this.settings.site_name}` : '联系我们'
  }
}
</script>

<style scoped>
.contact-page {
  min-height: 100vh;
  background: #ffffff;
}

/* Hero Section */
.hero-section {
  height: 470px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.1) 100%);
  z-index: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}

.hero-content {
  text-align: center;
  color: white;
}

.hero-title {
  font-size: 48px;
  font-weight: 700;
  margin: 0 0 16px 0;
  animation: fadeInUp 0.8s ease-out;
}

.hero-subtitle {
  font-size: 24px;
  margin: 0 0 16px 0;
  opacity: 0.95;
  animation: fadeInUp 0.8s ease-out 0.1s both;
}

.hero-description {
  font-size: 16px;
  line-height: 1.8;
  max-width: 800px;
  margin: 0 auto;
  opacity: 0.9;
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 主要联系区域 */
.main-contact-section {
  padding: 100px 0 80px;
  background: #f7f8fa;
}

.contact-wrapper {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 60px;
}

.section-title {
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: #333333;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -8px;
  width: 60px;
  height: 4px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  border-radius: 2px;
}

.form-subtitle {
  font-size: 16px;
  color: #666666;
  margin: 0 0 32px 0;
  line-height: 1.6;
}

.contact-form {
  background: #f8f9fa;
  padding: 32px;
  border-radius: 12px;
}

/* 详细信息区域 */
.details-list {
  margin-bottom: 40px;
}

.detail-item {
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
  align-items: flex-start;
}

.detail-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.detail-icon i {
  font-size: 20px;
  color: white;
}

.detail-content h4 {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 8px 0;
}

.detail-content p {
  font-size: 14px;
  color: #666666;
  margin: 0;
  line-height: 1.6;
}

.detail-note {
  font-size: 12px;
  color: #999999;
  display: block;
  margin-top: 4px;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .hero-section {
    height: 470px;
  }

  .hero-title {
    font-size: 36px;
  }

  .hero-subtitle {
    font-size: 20px;
  }


  .contact-wrapper {
    grid-template-columns: 1fr;
    gap: 40px;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 16px;
  }

  .hero-section {
    height: auto;
    min-height: 300px;
    padding: 80px 0 40px;
  }

  .hero-title {
    font-size: 26px;
    margin-bottom: 12px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .section-title {
    font-size: 24px;
    margin-bottom: 20px;
  }

  .section-subtitle {
    font-size: 14px;
    margin-bottom: 16px;
  }

  .contact-form {
    padding: 20px;
  }

  /* 主要联系区域优化 */
  .main-contact-section {
    padding: 30px 0;
  }

  /* 表单布局优化 */
  .contact-form-wrapper {
    padding: 20px 16px;
  }

  .contact-form-wrapper .section-title {
    font-size: 20px;
    margin-bottom: 16px;
  }

  /* 移动端让所有列变为全宽，覆盖Element UI的span布局 */
  .contact-form-wrapper >>> .el-col-12 {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .contact-form-wrapper >>> .el-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .contact-form-wrapper >>> .el-form-item {
    margin-bottom: 24px !important;
  }

  .contact-form-wrapper >>> .el-form-item__label {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 8px;
  }

  .contact-form-wrapper >>> .el-form-item__content {
    line-height: normal;
  }

  /* 修复错误提示显示问题 - 改为相对定位，不遮挡 */
  .contact-form-wrapper >>> .el-form-item__error {
    position: static !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    height: auto !important;
    min-height: 16px !important;
    margin-top: 5px !important;
    padding: 2px 0 !important;
    line-height: 1.5 !important;
    font-size: 12px !important;
    color: #f56c6c !important;
  }

  .contact-form-wrapper >>> .el-input__inner,
  .contact-form-wrapper >>> .el-textarea__inner {
    font-size: 14px;
  }

  /* 确保输入框和选择框都是100%宽度 */
  .contact-form-wrapper >>> .el-input,
  .contact-form-wrapper >>> .el-select {
    width: 100% !important;
  }

  /* 修复下拉框宽度不一致问题 */
  .contact-form-wrapper >>> .el-select .el-input,
  .contact-form-wrapper >>> .el-select .el-input__inner {
    width: 100% !important;
  }

  /* 按钮组：让两个按钮并排显示 */
  .contact-form-wrapper >>> .el-form-item:last-child {
    margin-bottom: 0;
  }

  .contact-form-wrapper >>> .el-form-item:last-child .el-form-item__content {
    display: flex !important;
    justify-content: space-between;
    gap: 10px;
  }

  .contact-form-wrapper >>> .el-form-item:last-child .el-button {
    flex: 1;
    margin-left: 0 !important;
    padding: 10px 8px !important;
    font-size: 14px !important;
  }

  .contact-form-wrapper >>> .el-form-item:last-child .el-button i {
    font-size: 14px;
  }

  .contact-form-wrapper >>> .el-form-item:last-child .el-button span {
    white-space: nowrap;
  }

  /* 联系详情优化 */
  .contact-details-wrapper {
    padding: 20px 16px;
  }

  .contact-details-wrapper .section-title {
    font-size: 20px;
    margin-bottom: 16px;
  }

  .detail-item {
    padding: 14px;
    margin-bottom: 10px;
  }

  .detail-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .detail-content h4 {
    font-size: 14px;
  }

  .detail-content p {
    font-size: 13px;
  }

  .qr-code-wrapper {
    padding: 16px;
  }

  .qr-code-image {
    width: 140px;
    height: 140px;
  }
}
</style>
